export default __webpack_public_path__ + "static/media/google-cloud.a9198089.svg";